import React from "react";
import { getLogoURL } from "../../../dashboard/Meta/Additional/LogoEditor/utils";
import { IProps } from "../types";
import { Container } from "./styles";
import { LOGO_HEIGHT } from "../styles";

const Logo = ({ choir }: Pick<IProps, "choir">) => {
    const { logo } = choir.meta.additional
    if (!logo) {
        return null;
    }
    return (
        <Container>
            <img width={LOGO_HEIGHT} src={getLogoURL(logo)} />
        </Container>
    );
};

export default Logo;
